export interface FrontendStoreLocator {
    id: number;
    name: string;
    lastname: string;
    franchising: boolean;
    address: string;
    countryCode: string;
    country: string;
    city: string;
    provinceCode: string;
    province: string;
    latitude: string;
    longitude: string;
    telephone: string;
}

export interface GroupedFrontendStoreLocator {
    [province: string]: FrontendStoreLocator[];
}

export interface FilterFrontendStoreLocator {
    franchising?: boolean | null;
    province?: number | null; // province
    country?: string | null;
    region?: string | null;
    coordinates?: string;
}

export interface FilterFrontendGeolocation {
    coordinates: string;
    franchising: boolean | null;
}

export enum StoreLocatorTypeForm {
    NoOne = 'no-one',
    Dealer = 'rivenditore',
    Franchising = 'franchising'
}

export interface SendStoreLocatorForm {
    name: string;
    lastname: string;
    email: string;
    telephone: string;
    province: string;
    city: string;
    organizationName: string;
    type: string; // settore
    dealerType: StoreLocatorTypeForm;
    vatNumber?: string;
    notes?: string | null;
}

export interface City {
    id: number;
    name: string;
}

export interface Country {
    id: number;
    name: string;
    isoCode: string;
}
